import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { GetSearchEngineName } from 'src/shared/SearchUI.service';
import { S04SiteSearchProps } from './S04SiteSearch.types';
import { useI18n } from 'next-localization';

export type S04SiteSearchModel = {
  site?: string;
  engine?: string;
  section: string[];
  dataModel: {
    numberOfSearchResultsPerPage: number;
    noResultsText: string;
    searchFieldPlaceholder: string;
    searchFieldLabel: string;
    searchButtonText: string;
  };
};

export function CreateS04SiteSearchModel(props: S04SiteSearchProps): S04SiteSearchModel {
  const { sitecoreContext } = useSitecoreContext();
  const { t } = useI18n();
  const { fields, params } = props;

  const site = sitecoreContext?.site?.name;

  const engine = GetSearchEngineName(site);

  const section =
    fields?.ScopeSearchToSection?.filter((i) => i.url)?.map((s) => s.url as string) || [];

  return {
    site,
    engine,
    section,
    dataModel: {
      numberOfSearchResultsPerPage: parseInt(params?.NumberOfSearchResultsPerPage ?? '5'),
      noResultsText: fields?.NoResultsText?.value || '<p>No results found</p>',
      searchFieldPlaceholder: t('SiteSearch-SearchFieldPlaceholder') || 'Enter a search term',
      searchFieldLabel: t('SiteSearch-SearchFieldLabel') || 'Search the site',
      searchButtonText: t('SiteSearch-SearchButtonText') || 'Search',
    },
  };
}
